const ROOM_TYPE = { key: "room_type", label: "Room Type", value: room => room.room_type_name || (room.type === "common" ? "Common area" : "Bedroom") };
const BED_SIZE = { key: "bed_size", label: "Bed Size", value: room => room.type === "bedroom" ? room.bed_size : null };
const REFURBISHMENT = { key: "refurbishment", label: "Refurbishment", value: room => room.flags?.refurbishment ? "Required" : null };

/** One presentation contract for every standard and configured TARlution stage. */
export const STAGE_LIST_METADATA = {
  internal_repairs: [ROOM_TYPE, BED_SIZE], external_repairs: [ROOM_TYPE, BED_SIZE],
  cleaning: [ROOM_TYPE, BED_SIZE], cleaning_inspection: [ROOM_TYPE, BED_SIZE],
  refurbishment: [ROOM_TYPE, REFURBISHMENT],
};

export const stageMetadata = stage => STAGE_LIST_METADATA[stage] || [ROOM_TYPE];

/** Select the shared modal experience without navigating away from the list. */
export function stageModalKind(stage, definition = {}) {
  if (stage === "key_return") return "key_return";
  if (["checkout_inspection", "maintenance_inspection"].includes(stage)) return "inspection";
  if (["internal_repairs", "external_repairs"].includes(stage)) return "room";
  if (stage === "completed") return "room";
  if (stage.startsWith("custom_") || definition.questions?.length || definition.interaction_mode === "form") return "form";
  return ["bag_and_bin", "painting", "cleaning", "cleaning_inspection", "welcome_packs", "refurbishment", "refurbishment_inspection"].includes(stage) ? "form" : "room";
}

export const ASSIGNMENT_FILTER_OPTIONS = [
  { id: "all", label: "All assignments" }, { id: "unassigned", label: "Unassigned" },
  { id: "mine", label: "Assigned to me" }, { id: "my_team", label: "Assigned to my team" },
  { id: "person", label: "Assigned to person" }, { id: "role", label: "Assigned to role/team" },
];

export function assignmentMatches(assignment, filter, user = {}, targetId = "") {
  if (filter === "all") return true;
  if (filter === "unassigned") return !assignment;
  if (filter === "mine") return assignment?.type === "user" && assignment.target_id === user.id;
  if (filter === "person") return assignment?.type === "user" && (!targetId || assignment.target_id === targetId);
  if (filter === "role") return assignment?.type === "role" && (!targetId || assignment.target_id === targetId);
  if (filter === "my_team") {
    const memberships = new Set([user.role_id, ...(user.role_ids || []), ...(user.effective_role_ids || [])].filter(Boolean));
    return assignment?.type === "role" && memberships.has(assignment.target_id);
  }
  return true;
}
